import React, { useMemo } from 'react';
import { Flex } from '@banhala/ui-kit';
import type { GoodsPiece } from 'shared/src/api/goodsService';
import { MeasurementTable } from './MeasurementTable';

interface Props {
  piece: GoodsPiece;
}

export const MeasurementBottom: React.FC<Props> = ({ piece }) => {
  const options = useMemo(() => {
    const rawOptions = piece.product_info.options;

    return rawOptions.filter(rawOption => {
      return rawOption.choices.some(choice => choice.is_chosen);
    });
  }, [piece.product_info.options]);

  if (options.length === 0) {
    return null;
  }

  return (
    <Flex padding={{ top: 10 }}>
      <MeasurementTable options={options} />
    </Flex>
  );
};
